export default __webpack_public_path__ + "static/media/icon_trust02.70a17099.png";